module.exports = __webpack_public_path__ + "static/media/bch.dd0affc6.svg";